import styled, { css } from 'styled-components';
import { media } from '../../../constants/media/media';
import theme from '../../../constants/theme';
import { Tab, Tabs } from '../../base/tabs/tabs';
import { A, H4 } from '../../base/typography';

export const HeaderMain = styled.div`
	margin-bottom: 3rem;
`;

export const ContentTabs = styled(Tabs)`
	margin-bottom: 4rem;
`;

export const ContentTab = styled(Tab)`
	padding: 0 3rem !important;
	${({ active }) =>
		active &&
		css`
			color: ${({ theme }) => theme.colors.primary};
		`};
`;

export const Heading = styled(H4)`
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	margin: 4rem 0 3rem 0;
`;

export const ShipmentCard = styled.div`
	margin-top: 3rem;
	box-shadow: 0px 11px 24px #ececec;

	span {
		font-size: 1.4rem;
		display: block;
		text-transform: uppercase;
		font-weight: 700;
		color: ${theme.colors.black};
	}

	a {
		margin-left: 1rem;
		text-decoration: underline;
	}

	div:last-child {
		border-right: 0;
	}

	${({ simple }) =>
		simple &&
		`
			padding: 4rem 3rem 3.5rem 3rem;
			text-align: center;
			border: 3px dashed ${theme.colors.grayLighter};

			svg {
			   margin: 0 1rem 0 0;
			}
		`}

	span {
		font-size: 1.4rem;
		display: block;
		text-transform: uppercase;
		font-weight: 700;
		color: ${theme.colors.black};
	}

	a {
		margin-left: 1rem;
		text-decoration: underline;
	}

	div:last-child {
		border-right: 0;
	}

	${({ simpleIcon }) =>
		simpleIcon &&
		`
            display: flex;
            justify-content: center;
            box-shadow: none;
			padding: 2rem;

			svg {
			    height: 3rem;
			    margin: 0 .5rem 0 0;
			}
		`};

	${({ blue }) =>
		blue &&
		`
			border: 1px solid ${theme.colors.secondaryLight};
			background-color: ${theme.colors.secondaryLightest};
			color: ${theme.colors.black};
			svg {
			    fill: ${theme.colors.secondary};
			}
		`};

	${({ red }) =>
		red &&
		`
			background-color: ${theme.colors.primary};
			color: ${theme.colors.white};
			svg {
			    path { fill: ${theme.colors.white};}
			}
		`};
`;

export const CardHeadingWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 2rem 3rem 1.5rem 3rem;
	color: ${theme.colors.black};
	border-bottom: 1px solid ${theme.colors.grayLighter};
	font-weight: 700;

	${media.mobileAndTabletOnly`
        border-bottom: 0;
        padding-bottom: 0;
    `}
`;

export const CardHeading = styled.p`
	display: block;
`;

export const CardMore = styled(A)`
	display: block;
	cursor: pointer;
	padding: 0;

	svg {
		max-height: 2.5rem;
		fill: ${theme.colors.grayLight};
	}
	${media.mobileAndTabletOnly`
        display: none;
    `}
`;

export const ShipmentInfo = styled.div`
	div {
		font-size: 1.6rem;
		display: inline-block;
		padding: 1.5rem 3rem;
		border-right: 1px solid ${theme.colors.grayLighter};
	}

	div:first-child {
		color: ${theme.colors.secondary};
	}

	${media.mobileAndTabletOnly`

        div {
            display: block;
            border-right: 0;
            padding-top: 0;
        }

        div:first-child {
            border-bottom: 1px solid ${theme.colors.grayLighter};
            padding-bottom: 2rem;
            margin-bottom: 1.5rem;
        }

        div:first-child span {
            display: none;
        }
    `}
`;

export const MobileShowMore = styled.div`
	display: none;

	${media.mobileAndTabletOnly`
        display: block;
        border-top: 1px solid ${theme.colors.grayLighter};
        padding: 2rem 3rem 1.5rem 3rem;
        text-align: right;
    `}
`;

export const ShipmentAdditionalInfo = styled.div`
	display: flex;
	align-items: stretch;
	border-top: 1px solid ${theme.colors.grayLighter};
`;

export const ShipmentsAdditionalInfoHeading = styled.div`
	color: ${theme.colors.black};
	font-weight: 700;
	font-size: 2.5rem;
	margin-bottom: 4rem;
`;

export const TrackingInfo = styled.div`
	flex: 0 0 55%;
	padding: 4rem 5rem;

	${media.mobileOnly`
        flex: 0 0 100%;
    `}
`;

export const MapContainer = styled.div`
	flex: 1;
	min-height: 40rem;

	${media.mobileOnly`
        display: none;
    `}
`;

export const Dot = styled.div`
	width: 1.7rem;
	height: 1.7rem;
	margin: 1.5rem 3rem;
	border-radius: 100%;
	background-color: ${theme.colors.secondary};
	border: 0.4rem solid white;
	justify-self: center;
	align-self: center;

	${({ active }) =>
		active &&
		`
        background-color: ${theme.colors.primary};
        position: relative;
        border: 0;

        &:before {
            background: none;
            border: 3px solid #fff;
            content: "";
            display: block;
            position: absolute;
            border-radius: 100%;
            top: 1px;
            left: 1px;
            right: 1px;
            bottom: 1px;
            pointer-events: none;
        }
    `}
`;

export const Line = styled.div`
	width: 1px;
	height: 7rem;
	margin: -1rem 0;
	justify-self: center;
	background-color: ${theme.colors.secondary};
`;

export const Timestamp = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
`;

export const Description = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
	font-size: 1.6rem;
`;

export const GridWrapper = styled.div`
	display: grid;
	grid-template-columns: auto auto auto;
	grid-template-rows: repeat;
	column-gap: 10px;
`;
